var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendarPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 45.5V32.5M32.5 39H45.5",
    stroke: "#02698C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 24.9163V19.0663C45.5 15.426 45.5 13.6058 44.7915 12.2154C44.1684 10.9923 43.174 9.99798 41.9509 9.3748C40.5605 8.66634 38.7403 8.66634 35.1 8.66634H16.9C13.2597 8.66634 11.4395 8.66634 10.0491 9.3748C8.82601 9.99798 7.83163 10.9923 7.20846 12.2154C6.5 13.6058 6.5 15.426 6.5 19.0663V37.2663C6.5 40.9067 6.5 42.7269 7.20846 44.1173C7.83163 45.3403 8.82601 46.3347 10.0491 46.9579C11.4395 47.6663 13.2597 47.6663 16.9 47.6663H27.0833M45.5 21.6663H6.5M34.6667 4.33301V12.9997M17.3333 4.33301V12.9997",
    stroke: "#02698C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarPlus);
export default __webpack_public_path__ + "static/media/IconCalendarPlus.160c1838c1845f9128142628f657331a.svg";
export { ForwardRef as ReactComponent };